import React, { useCallback, useMemo } from 'react';

import { useHistory, useLocation } from 'react-router';

import { Stack } from '@mui/material';

import MmaoOffersResultsTable from './MmaoOffersResultsTable';
import MmaoOffersSearchForm from './MmaoOffersSearchForm';
import { getMmaoOffersSearchInputFromSearchParams } from './utils';

function MmaoOffersResultsContainer() {
  const history = useHistory();
  const location = useLocation();

  const urlSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

  const searchInput = useMemo(() => getMmaoOffersSearchInputFromSearchParams(urlSearchParams), [urlSearchParams]);

  const pageNumber = useMemo(() => {
    const page = urlSearchParams.get('page');
    return page ? Number(page) : 1;
  }, [urlSearchParams]);

  const handleSearchFormSubmission = useCallback(
    (formObject: Record<string, string>) => {
      history.push({ search: new URLSearchParams(formObject).toString() });
    },
    [history],
  );

  const handlePageChange = useCallback(
    (pageIndex: number) => {
      const params = new URLSearchParams(urlSearchParams);
      if (pageIndex) {
        params.set('page', String(pageIndex + 1));
      } else {
        params.delete('page');
      }
      history.push({ search: params.toString() });
    },
    [urlSearchParams, history],
  );

  return (
    <Stack direction="column" spacing={2}>
      <MmaoOffersSearchForm initialInput={searchInput} onSubmit={handleSearchFormSubmission} />
      <MmaoOffersResultsTable searchInput={searchInput} pageIndex={pageNumber - 1} onPageChange={handlePageChange} />
    </Stack>
  );
}

export default MmaoOffersResultsContainer;
